export const ORDERS_LIST_INITING         = 'MARKETING_ORDERS_LIST_INITING'
export const ORDERS_LIST_REQUESTING      = 'MARKETING_ORDERS_LIST_REQUESTING'
export const ORDERS_LIST_SUCCESS         = 'MARKETING_ORDERS_LIST_SUCCESS'
export const ORDERS_LIST_ERROR           = 'MARKETING_ORDERS_LIST_ERROR'   

export const ORDERS_ADDED_CUSTOMERS_REQUESTING      = 'MARKETING_ORDERS_ADDED_CUSTOMERS_REQUESTING'

export const ORDERS_LIST_NV_REQUESTING      = 'MARKETING_ORDERS_LIST_NV_REQUESTING'
export const ORDERS_LIST_NV_SUCCESS         = 'MARKETING_ORDERS_LIST_NV_SUCCESS'
export const ORDERS_LIST_NV_ERROR           = 'MARKETING_ORDERS_LIST_NV_ERROR'   

export const ORDERS_REMOVE_ITEM_REQUESTING      = 'MARKETING_ORDERS_REMOVE_ITEM_REQUESTING'
export const ORDERS_REMOVE_ITEM_SUCCESS         = 'MARKETING_ORDERS_REMOVE_ITEM_SUCCESS'
export const ORDERS_REMOVE_ITEM_ERROR           = 'MARKETING_ORDERS_REMOVE_ITEM_ERROR'   

export const ORDERS_KHACHHANG_REQUESTING         = 'MARKETING_ORDERS_KHACHHANG_REQUESTING'
export const ORDERS_KHACHHANG_SUCCESS            = 'MARKETING_ORDERS_KHACHHANG_SUCCESS'
export const ORDERS_KHACHHANG_ERROR              = 'MARKETING_ORDERS_KHACHHANG_ERROR'   

export const ORDERS_DAILY_REQUESTING         = 'MARKETING_ORDERS_DAILY_REQUESTING'
export const ORDERS_DAILY_SUCCESS            = 'MARKETING_ORDERS_DAILY_SUCCESS'
export const ORDERS_DAILY_ERROR              = 'MARKETING_ORDERS_DAILY_ERROR'  

export const ORDERS_APPROVE_LIST_REQUESTING     = 'MARKETING_ORDERS_APPROVE_LIST_REQUESTING'  
export const ORDERS_APPROVE_SET_LIST            = 'MARKETING_ORDERS_APPROVE_SET_LIST'  
export const ORDERS_SET_APPROVE_MESSAGE         = 'MARKETING_ORDERS_SET_APPROVE_MESSAGE'  
export const ORDERS_SET_APPROVE_ERROR           = 'MARKETING_ORDERS_SET_APPROVE_ERROR'  

export const ORDERS_EXPORT_XLS_INITING         = 'MARKETING_ORDERS_EXPORT_XLS_INITING'
export const ORDERS_EXPORT_XLS_REQUESTING      = 'MARKETING_ORDERS_EXPORT_XLS_REQUESTING'
export const ORDERS_EXPORT_XLS_SUCCESS         = 'MARKETING_ORDERS_EXPORT_XLS_SUCCESS'
export const ORDERS_EXPORT_XLS_ERROR           = 'MARKETING_ORDERS_EXPORT_XLS_ERROR'

export const ORDERS_LIST_NV_API                 = '/api/v1/users/get_list_by_quanly'
export const ORDERS_DAILY_API                   = '/api/v1/kho/getKhoCapDaiLyOfUser'
export const ORDERS_LIST_API                    = '/api/v2/export/marketing_find_orders'
export const ORDERS_EXPORT_API                  = '/api/v2/export/orders_export_by_store'
export const ORDERS_REMOVE_ITEM_API             = '/api/v2/export/remove_item'
export const ORDERS_KHACHHANG_API               = '/api/v2/export/marketing_get_customers_for_order'
export const ORDERS_APPROVE_LIST_API            = '/api/v2/export/approve_order'
export const ORDERS_ADDED_CUSTOMERS_API         = '/api/v2/export/marketing_list_customer_of_order'


// WEBPACK FOOTER //
// ./src/views/MarketingOrders/constants.js